import { render, staticRenderFns } from "./PatientLog.vue?vue&type=template&id=24cb613a&scoped=true&"
import script from "./PatientLog.vue?vue&type=script&lang=ts&"
export * from "./PatientLog.vue?vue&type=script&lang=ts&"
import style0 from "./PatientLog.vue?vue&type=style&index=0&id=24cb613a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb613a",
  null
  
)

export default component.exports